import makeStyles from "@material-ui/core/styles/makeStyles";

const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: "500px",
    paddingTop: "140px !important",
    paddingBottom: "140px !important",
    paddingLeft: "7% !important",
    paddingRight: "7% !important",
    backgroundColor: "#f0f3f5",
    position: "relative",
  },
  root2: {
    minHeight: "500px",
    paddingBottom: "140px !important",
    paddingLeft: "7% !important",
    paddingRight: "7% !important",
    backgroundColor: "#f0f3f5",
    position: "relative",
  },
  filterContainer: {
    padding: "60px 0 0 0",
    display: "flex",
    alignItems: "center",
  },
  selectContainer: {
    display: "flex",
    justifyContent: "right",
    [theme.breakpoints.down("md")]: {
      marginBottom: "10px",
    },
  },
  select: {
    fontSize: "16px",
    width: "100%",
    whiteSpace: "nowrap",
    textAlign: "left",
  },
  select2: {
    fontSize: "16px",
    width: "240px",
    whiteSpace: "nowrap",
    textAlign: "left",
    marginRight: "10px",
  },
  heading: {
    fontFamily: "Montserrat",
    fontSize: "40px",
    fontWeight: "bold",
    color: "#563a96",
  },
  paragraph: {
    fontFamily: "Montserrat",
    fontSize: "20px",
    color: "#3e4a59",
    marginTop: "30px",
  },
  cardsContainer: {
    marginLeft: "-8%",
    marginRight: "-8%",
    marginTop: "30px",
    paddingTop: "10px",
    background: `linear-gradient(180deg, rgba(58,194,215,0.4125000341933649) 0%, rgba(240,243,245,1) 53%)`,
  },
  mainCardContainer: {
    padding: "0 7% 0 7% !important",
  },
}));

export default useStyles;
